import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SocialAuthService } from 'angularx-social-login';
import { smoothlyMenu } from '../../../app.helpers';
import { AutenticacionService } from '../../../core/services/autenticacion.service';
import { InfoUsuarioService } from '../../../core/services/info-usuario.service';
import { DialogConfirmacionComponent } from '../../shared/dialog-confirmacion/dialog-confirmacion.component';
declare var jQuery:any;

@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html'
})

export class TopNavbarComponent {
  isExternalAuth: boolean;
  tabla: string = 'Personal';

  constructor(private infoUsuarioService: InfoUsuarioService, private router: Router, public dialog: MatDialog, private autenticacionService: AutenticacionService, private _socialAuthService: SocialAuthService) { }

  ngOnInit()
  {
    this._socialAuthService.authState.subscribe(user =>
    {
      this.isExternalAuth = user != null;
    })
  }

  toggleNavigation(): void {
    jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

  cerrarSesion(): void
  {
    const dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Cerrar sesión?";

    dialogRef.afterClosed().subscribe(async result =>
    {
      if (result !== null && result)
      {
        await this.infoUsuarioService.CerrarSesion();

        if (this.isExternalAuth)
          this.autenticacionService.signOutExternal();

        this.router.navigateByUrl('login');
      }
    });
  }

}
